import React from "react";
import "../../css/Footer.css";
import { ReactComponent as FacebookIcon } from "../../assets/icons/social_icons-02.svg";
import { ReactComponent as InstaIcon } from "../../assets/icons/instagram_icon 1.svg";
import { ReactComponent as LinkedInIcon } from "../../assets/icons/social_icons-01.svg";
import { ReactComponent as PhoneIcon } from "../../assets/icons/contact_icons-16.svg";
import { ReactComponent as EmailIcon } from "../../assets/icons/contact_icons-15.svg";
import { useNavigate } from "react-router-dom";
function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="footer" id="contact">
      <div className="footer-container">
        <div className="footer-Content">
          <div className="footer-contact">
            <div className="contact-item">
              <span className="icon">
                <EmailIcon />
              </span>
              <span>
                <a href="mailto:michael@avarosemortgages.co.uk">
                  michael@avarosemortgages.co.uk
                </a>
              </span>
            </div>
            <div className="contact-item">
              <span className="icon">
                <PhoneIcon />
              </span>
              <span>
                <a href="tel:07759727170">07759 727170</a>
              </span>
            </div>
          </div>
          <div className="footer-social">
            <a
              href="https://www.instagram.com/avarosemortgages/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon facebook"
              aria-label="Instagram"
            >
              <InstaIcon />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61580737965094"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon facebook"
              aria-label="Facebook"
            >
              <FacebookIcon />
            </a>

            <a
              href="https://www.linkedin.com/in/tax-advisor/
 "
              className="social-icon linkedin"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedInIcon />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-disclaimer">
        <div className="footer-links">
          <h2
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </h2>
          <h2
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => navigate("/terms-and-conditions")}
          >
            Terms & Conditions
          </h2>
        </div>
        <p>
          Ava Rose Mortgages Ltd is an Appointed Representative of Rosemount
          Financial Solutions (IFA) Ltd which is authorised and regulated by the
          Financial Conduct Authority. Rosemount Financial Solutions (IFA) Ltd
          is entered on the Financial Services Register under reference 535515.
          Ava Rose Mortgages Ltd is registered in England and Wales (Company
          Number: 16794792). Registered office: Arum House, 21 Mill Rise,
          Robertsbridge, East Sussex, England, TN32 5EF. The information on this
          website is subject to the UK regulatory regime and is intended for
          consumers in the UK.
          {/* <a
            href="https://register.fca.org.uk/s/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            (https://register.fca.org.uk/s/)
          </a>{" "}
          under reference 535515. Rosemount Financial Solutions (IFA) Ltd is
          authorised and regulated by the Financial Conduct Authority. */}
        </p>
        {/* <p>
          Registered as a Limited Company in England & Wales No 16794792.
          Registered Address: <br />
          Arum House, 21 Mill Rise, Robertsbridge, East Sussex, England, TN32
          5EF.
        </p> */}
      </div>
    </footer>
  );
}

export default Footer;